<template>
  <div class="flex-container">
    <!-- End goal alerts -->
    <div class="dashboard-card flex-grow">
      <div class="card-header">
        Doelmeter <sup>&reg;</sup>
      </div>
      <div style="min-height:200px;max-width:200px;margin:10px auto -10px;">
        <scoreMeter v-model="currentPort.sat.score" :showNotice="false" />
      </div>
    </div>
    <div class="dashboard-card flex-33">
      <div class="card-header">Portefeuille #{{$parent.port}}
      <br />
      <span class="grey concat" style="font-size: 12px">
        bijgewerkt op
        <b>
          {{ $parent.positions[0] && $parent.positions[0].date
            ? (new Date($parent.positions[0].date)).toLocaleDateString()
            : '-'
          }}
        </b>
      </span>
    </div>
      <div class="card-content2">
        &euro;&nbsp;{{formatPrice(total, true)}},-
        <template v-if="currentPort.target > 0">
          van uw <b>&euro; {{formatPrice(currentPort.target, true)}},-</b> doel
          <a class="editIcon" @click="$parent.redo()"><awesomeIcon icon="edit"/></a>
          <br>
          <span class="hide-mobile">
          <span class="faded-txt">
            Voortgang {{formatPrice((total / currentPort.target) * 100)}}%
            </span><br>
          </span>
        </template>
        <template v-if="currentPort.cashflow.length > 0">
          <br>
          <template v-if="currentPort.cashflow[0].value < 0">
            Uitkering op jaarbasis <br><b>circa &euro;
            <template v-if="currentPort.cashflow[0].interval=='M'">
              {{formatPrice(-currentPort.cashflow[0].value * 12, true)}},-
            </template>
            <template v-if="currentPort.cashflow[0].interval=='Q'">
              {{formatPrice(-currentPort.cashflow[0].value * 4, true)}},-
            </template>
            <template v-if="currentPort.cashflow[0].interval=='H'">
              {{formatPrice(-currentPort.cashflow[0].value * 2, true)}},-
            </template>
            <template v-if="currentPort.cashflow[0].interval=='Y'">
              {{formatPrice(-currentPort.cashflow[0].value, true)}},-
            </template>
            </b><br>
          </template>
          <template v-else>
            <b>&euro; {{formatPrice(currentPort.cashflow[0].value, true)}},- </b>
            <template v-if="currentPort.cashflow[0].interval=='M'">maandelijkse</template>
            <template v-if="currentPort.cashflow[0].interval=='Q'">kwartaal</template>
            <template v-if="currentPort.cashflow[0].interval=='H'">halfjaar</template>
            <template v-if="currentPort.cashflow[0].interval=='Y'">jaarlijkse</template>
            inleg
            <a class="editIcon" @click="$parent.redo()"><awesomeIcon icon="edit"/></a>
            <template v-if="currentPort.cashflow[0].value > 0">
              <br>Automatische incasso:
              <span
                :class="{
                  'green': currentPort.cashflow[0].collect,
                  'red': !currentPort.cashflow[0].collect,
                }"
              >
                {{currentPort.cashflow[0].collect ? 'Aan ' : 'Uit '}}
              </span>
              <a class="editIcon" @click="$parent.redo()"><awesomeIcon icon="edit"/></a><br>
            </template>
            <template v-else>
              <span
                v-if="noCashflow" @click="deposit=true"
                style="color:#d9534f; cursor:pointer;"
              >
                (<awesomeIcon icon="exclamation-circle"/> Nog niet gestort)<br>
              </span>
              <span v-else-if="lastDeposit.nextDate">
                <span class="faded-txt">
                  Volgende verwacht: {{(new Date(lastDeposit.nextDate)).toLocaleDateString()}}
                </span><br>
              </span>
            </template>
          </template>
        </template>
        <br/>
        Alertwaarde <b>{{currentPort.alert}}% </b>
        <a class="editIcon" @click="editScore=true"><awesomeIcon icon="edit"/></a>
      </div>
      <div class="card-bottom">
        <a
          v-if="currentPort.type != 8
            && currentPort.type != 9
            && currentPort.type != 10"
          @click="deposit=true" class="button secondary"
        >
          Bijstorten <awesomeIcon icon="wallet"/>
        </a>
        <a @click="clickPlan()" class="button secondary">
          Beleggingsplan inzien <awesomeIcon icon="file-download"/>
        </a>
      </div>
    </div>
    <div class="dashboard-card flex-33">
      <div class="card-header2" style="max-width:250px;">
        {{currentPort.name || typeToText(currentPort.type)}}
        <a class="editIcon" @click="editName=true"><awesomeIcon icon="edit"/></a>
      </div>
      <div class="card-content2">
        <span class="hide-mobile">{{typeToText(currentPort.type)}}</span>
        <span class="hide-mobile faded-txt"><br>Profiel {{currentPort.profile}}</span>
        <div class="show-mobile">Profiel {{currentPort.profile}}</div>
        <br class="hide-mobile"><br class="hide-mobile">
        Resterende looptijd
        <b v-if="daysTillGoal > 365">
          {{Math.ceil(daysTillGoal / 366)}} jaar
        </b>
        <b v-else-if="daysTillGoal > 1">
          {{Math.ceil(daysTillGoal)}} dagen
        </b>
        <b v-else-if="daysTillGoal > 0">
          1 dag
        </b>
        <br />
        <span class="faded-txt">
          Doeldatum
          <b>
            {{ currentPort && currentPort.target_date
              ? (new Date(currentPort.target_date)).toLocaleDateString()
              : '-'
            }}
          </b>
          <a class="editIcon" @click="$parent.redo()">&nbsp;<awesomeIcon icon="edit"/></a>
        </span>
        <br /><br />
        <!-- Gouden handdruk -->
        <span class="faded-txt" v-if="this.currentPort.type === 10 && remainingTime">
          Verwacht resterende looptijd
          <b>
            {{ Math.round((new Date(remainingTime) - new Date) / 31536000000) }} jaar
          </b>
          <awesomeIcon
            style="cursor: pointer"
            icon="info-circle"
            @click="timeModal = true"
          />
          Verwachte doeldatum <b>{{ remainingTime.split("-").reverse().join("-") }}</b>
          <br /><br />
        </span>
        Lifecycle:
        <span
          :class="{
            'green': currentPort.lifecycle,
            'red': !currentPort.lifecycle,
          }"
        >
          {{ currentPort.lifecycle ? 'Aan ' : 'Uit ' }}
        </span>
        <awesomeIcon
          style="cursor: pointer"
          icon="info-circle"
          @click="lifeCycleModal = true"
        />
        <br><br class="hide-mobile">
        <span v-if="notUpToDate" @click="update=true" style="color:#d9534f; cursor:pointer;">
          <awesomeIcon icon="exclamation-circle"/>
        </span><br>
        <span v-if="currentPort.sat.date != currentPort.date" class="faded-txt">
          (haalbaarheid nog niet bijgewerkt)
        </span>
      </div>
      <div class="card-bottom">
        <a class="button secondary" @click="$parent.redo()">
          Doel wijzigen <awesomeIcon icon="cog"/>
        </a>
        <a class="button secondary" @click="$parent.clickDetails('new_class')">
          Posities bekijken <awesomeIcon icon="chart-line"/>
        </a>
      </div>
    </div>

    <modalWindow v-if="lifeCycleModal" @close="lifeCycleModal = false" width="600">
      <div class="titlebar"><awesomeIcon icon="info-circle"/> Wat is Lifecycle</div>
      <div style="width: 95%; margin: auto">
        <p style="font-weight: 150%">
          Uw Lifecycle staat <b>{{ currentPort.lifecycle ? 'Aan' : 'Uit' }}</b>.
        </p>
        <p v-if="currentPort.lifecycle" style="line-height: 150%">
          Dit betekent dat wij richting het eind van de looptijd het risico binnen de portefeuille
          afbouwen zodat de kans op een nog moeilijk te herstellen verlies afneemt.
        </p>
        <p v-else style="line-height: 150%">
          Het risico binnen de portefeuille wordt richting het eind van de looptijd niet
          afgebouwd.
        </p>
        <p style="line-height: 150%">
          Hieronder staat een overzicht van de risico afbouw die wordt doorgevoerd. De getoonde
          profielen zijn de ‘hoogst’ geaccepteerde profielen voor de bijbehorende resterende
          looptijd.
          <br /><br />
          Uw huidige profiel is <b>{{  currentPort.profile.slice(-1) }}</b> en uw resterende
          looptijd is
          <b v-if="daysTillGoal > 365">
            {{Math.ceil(daysTillGoal / 366)}} jaar.
          </b>
          <b v-else-if="daysTillGoal > 1">
            {{Math.ceil(daysTillGoal)}} dagen.
          </b>
          <b v-else-if="daysTillGoal > 0">
            1 dag.
          </b>
        </p>
        <div>
          <table class="transparent-table">
            <colgroup>
              <col class="unselected-profile"/>
              <col
                :class="currentPort.profile === 'Doelbeleggen E'
                  ? 'selected-profile'
                  : 'unselected-profile'
                "
              />
              <col
                :class="currentPort.profile === 'Doelbeleggen D'
                  ? 'selected-profile'
                  : 'unselected-profile'
                "
              />
              <col
                :class="currentPort.profile === 'Doelbeleggen C'
                  ? 'selected-profile'
                  : 'unselected-profile'
                "
              />
              <col
                :class="currentPort.profile === 'Doelbeleggen B'
                  ? 'selected-profile'
                  : 'unselected-profile'
                "
              />
              <col
                :class="currentPort.profile === 'Doelbeleggen A'
                  ? 'selected-profile'
                  : 'unselected-profile'
                "
              />
            </colgroup>
            <tr>
              <td style="width:150px; font-weight: bold;">Resterende looptijd</td>
              <td v-for="year in years" :key="year">{{ year }}</td>
            </tr>
            <tr>
              <td style="width:150px; font-weight: bold;">Profiel maximaal</td>
              <td v-for="profile in profiles" :key="profile">{{ profile }}</td>
            </tr>
          </table>
        </div>
        <p style="font-weight: 150%">
          Mocht u hierover vragen hebben, neem dan contact met ons op.
        </p>
      </div>
    </modalWindow>
    <modalWindow v-if="timeModal" @close="timeModal = false" width="600">
      <div class="titlebar">
        <awesomeIcon icon="info-circle"/> Wat is verwachte looptijd / doeldatum
      </div>
      <div style="width: 95%; margin: auto">
        <p style="font-weight: 150%">
          Uw verwachte looptijd is:
          <b>
            {{ remainingTime
              ? Math.round((new Date(remainingTime) - new Date) / 31536000000)
              : '-'
            }} jaar.
          </b>
          <br />
          Uw verwachte doeldatum is:
          <b>
            {{ remainingTime
              ? remainingTime.split("-").reverse().join("-")
              : '-'
            }}.
          </b>
        </p>
        <p style="line-height: 150%">
          U heeft een Gouden handdruk uitkering waarbij
          <b> de hoogte van de uitkering vast staat </b>
          en de looptijd variabel is. Afhankelijk van het resultaat van uw beleggingen zal de
          looptijd daardoor langer of korter zijn dan de looptijd die bij aanvang is getoond.
          <br /><br />
          Wij tonen u hier de verwachte doeldatum en bijbehorende verwachte looptijd.
          Die zal van dag tot dag anders (kunnen) zijn. Deze verwachte doeldatum is gebaseerd op
          onze scenario/projectie berekeningen en geeft u een indicatie.
          <br /><br />
          Mocht u hierover vragen hebben, neem dan contact met ons op.
        </p>
      </div>
    </modalWindow>

    <modalWindow v-if="deposit" @close="deposit=false;pick=null">
      <div class="titlebar">Bijstorten</div>
      <div class="form-error" style="padding:10px 20px;" v-if="amount < 1">
        Geen geldig bedrag.
      </div>
      <div style="padding:20px;" v-if="!bankSelect && !pick">
        <customInput v-model="amount" type="money" label="Bedrag"/>
        <p class="msg" style="margin: 5px;" v-if="amount > 999">
          Let op: Wanneer u via iDeal een hoog geldbedrag overboekt, kan afhankelijk van de bank
          een maximum gelden.
        </p>
        <button @click="calcSat();bankSelect=true" style="width:100%;margin-top:10px;">
          Overmaken
        </button>
      </div>
      <div v-if="bankSelect && !pick">
        <span v-if="msg" class="form-error">
          {{ msg }}
        </span>
        <div class="form-notice" style="padding:15px 20px;">
          Nieuwe haalbaarheidsscore <b>{{formatPrice(newSat, true)}}%</b>
        </div>
        <div style="padding:20px;">
          Stort alleen vanuit uw vaste tegenrekening!<br><br>
          <span v-if="currentPort.contra" style="font-size: larger">
            {{currentPort.contra.replace(new RegExp('_', 'g'), '*')}}<br><br>
          </span>
          <form @submit.prevent>
            <select v-model="selected">
              <option v-for="issuer in issuers" :key="issuer.id" :value="issuer.id">
                {{issuer.name}}
              </option>
            </select>
            <button
              v-if="!pick"
              @click="newIdeal(selected)"
              style="width:100%; margin-top:10px;"
            >
              iDeal betaling
            </button>
            <button
              v-if="!pick"
              @click="pick='bank'"
              style="width:100%;margin-top:10px;"
            >
              Bank overschrijving
            </button>
          </form>
        </div>
        <a class="block-button" @click="bankSelect=!bankSelect">
          <awesomeIcon icon="chevron-left"/> Terug
        </a>
      </div>
      <template v-if="pick=='bank'">
        <div style="padding:20px;">
          U kunt een geldbedrag op uw beleggingsrekening bijstorten via onderstaand IBAN-nummer.
          Vermeld in de omschrijving uw portefeuillenummer.<br>
          <br>
          <table>
            <tr style="background-color:#fff;">
              <th>IBAN</th><td>NL 85 ABNA 042 619 8212</td>
            </tr>
            <tr style="background-color:#fff;">
              <th>Tenaamstelling</th><td>Stichting Collectieve Beleggersgiro</td>
            </tr>
            <tr><th>Portefeuille</th><td>{{$parent.port}}</td></tr>
          </table>
        </div>
        <a class="block-button" @click="pick=!pick">
          <awesomeIcon icon="chevron-left"/> Terug
        </a>
      </template>
    </modalWindow>

    <modalWindow v-if="update" @close="update=false">
      <div class="titlebar">Gegevens nog niet bijgewerkt.</div>
      <p>
        Benodigde data, van bijvoorbeeld de depotbank, is nog niet ontvangen.<br><br>
        Dit kan gebeuren na feestdagen, dan ontvangen wij geen nieuwe data.<br><br>
        Maar ook door een storing,
        dan doen we er uiteraard alles aan dit zo snel mogelijk op te lossen.
      </p>
    </modalWindow>

    <modalWindow v-if="editScore" @close="editScore=false">
      <div class="titlebar">Alertwaarde aanpassen</div>
      <form @submit.prevent>
        <input type=number ref="alert" :value="currentPort.alert" placeholder="Alertwaarde">
        <input type=submit @click="updateAlert" value="Alertwaarde aanpassen">
      </form>
    </modalWindow>

    <modalWindow v-if="editName" @close="editName=false">
      <div class="titlebar">Doelnaam aanpassen</div>
      <form @submit.prevent>
        <input type=text ref="name" :value="currentPort.name" placeholder="Doelnaam">
        <input type=submit @click="updateName" value="Doelnaam aanpassen">
      </form>
    </modalWindow>

  </div>
</template>

<script>
import {
  sumBy,
  filter,
  find,
  findIndex,
} from 'lodash-es';
import scoreMeter from '../ui/scoreMeter';

export default {
  components: {
    scoreMeter,
  },
  name: 'Goal2Widget',
  data() {
    return {
      lifeCycleModal: false,
      timeModal: false,
      editName: false,
      editScore: false,
      amount: '50',
      issuers: [],
      update: false,
      deposit: false,
      newSat: null,
      pick: null,
      bankSelect: null,
      selected: null,
      msg: '',
      years: ['5 jaar of meer', '4 jaar', '3 jaar', '2 jaar', '1 jaar of minder'],
      profiles: ['E', 'D', 'C', 'B', 'A'],
    };
  },
  props: {
    watch: Boolean,
  },
  created() {
    this.sdk.getIssuers((response) => {
      if (response.status === 200) {
        this.issuers = response.data;
        const found = this.currentPort.contra
          ? findIndex(this.issuers, (o) => o.id.includes(
            this.currentPort.contra.substr(4, 4),
          ))
          : 0;
        this.selected = response.data[found > 0 ? found : 0].id;
      }
    });
    if (this.currentPort.cashflow[0] && this.currentPort.cashflow[0].value) {
      this.amount = `${this.currentPort.cashflow[0].value}`;
    }
  },
  watch: {
    watch() {
      this.deposit = this.watch;
    },
    deposit() {
      this.calcSat();
      this.$parent.deposit = this.deposit;
    },
  },
  methods: {
    infoTitle() {
      if (Number(this.currentPort.lifecycle) === 1) {
        return 'Dit betekent dat wij richting het eind van de looptijd het risico binnen de portefeuille afbouwen zodat de kans op een \n nog moeilijk te herstellen verlies afneemt. Mocht u hierover vragen hebben, neem dan contact met ons op.';
      }
      return 'Het risico binnen de portefeuille wordt richting het eind van de looptijd niet afgebouwd. \n Mocht u hierover vragen hebben, neem dan contact met ons op.';
    },
    clickPlan() {
      this.$parent.$parent.other = 'plan';
      this.$store.state.currentView = 'Reports';
    },
    typeToText(type) {
      if (type === 1) {
        return 'Zorgpotje';
      }
      if (type === 2) {
        return 'Hypotheek';
      }
      if (type === 3) {
        return 'Studie kind';
      }
      if (type === 4) {
        return 'Grote Aankoop';
      }
      if (type === 5) {
        return 'Pensioen';
      }
      if (type === 6) {
        return 'Levensonderhoud';
      }
      if (type === 7) {
        return 'Pensioen (Box 1)';
      }
      if (type === 8) {
        return 'Leefrente (Box 1)';
      }
      if (type === 9) {
        return 'Gouden handdruk (opbouwend)';
      }
      if (type === 10) {
        return 'Gouden handdruk (uitkerend)';
      }
      if (type === 11) {
        return 'Netto lijfrente (opbouwend)';
      }
      if (type === 12) {
        return 'Netto lijfrente(uitkerend)';
      }
      return 'Vermogensopbouw';
    },
    updateName() {
      this.editName = false;
      this.currentPort.name = this.$refs.name.value;
      this.sdk.modifyPort(
        this.$store.state.currentPort,
        this.$refs.name.value,
        null,
        null,
        () => { },
      );
    },
    updateAlert() {
      this.editScore = false;
      let value = Number(this.$refs.alert.value);
      if (!(value >= 0 && value <= 100)) {
        value = 50;
      }
      this.currentPort.alert = value;
      this.sdk.modifyPort(
        this.$store.state.currentPort,
        null,
        value,
        null,
        () => { },
      );
    },
    calcSat() {
      this.sdk.getSat(
        this.$store.state.currentPort,
        { cashflow: this.amount },
        (response) => {
          if (response.status === 200) {
            this.newSat = Math.min(response.data.score, 99);
          }
        },
      );
    },
    newIdeal(issuer) {
      this.sdk.portNewIdeal(
        this.$store.state.currentPort,
        issuer,
        this.amount,
        (response) => {
          if (response.status === 200) {
            window.location.href = response.data;
          } else if (response.status === 429) {
            if (response.data.transactionTimeout === 'timeout') {
              this.msg = 'Te veel transactiepogingen in de laatste minuut, probeer het over een paar minuten nog eens.';
            } else if (response.data.transactionTimeout === 'ban') {
              this.msg = 'Te veel transactiepogingen in de laatste 12 uur, probeer het over 24 uur nog eens.';
            }
          }
        },
      );
    },
  },
  computed: {
    remainingTime() {
      const pvvidata = JSON.parse(this.currentPort.sat.raw || '[]');
      if (pvvidata.length > 0) {
        for (let i = 0; i < pvvidata.length; i += 1) {
          if (pvvidata[i].vN <= 0) {
            return pvvidata[i].Date;
          }
        }
      }
      return null;
    },
    currentPort() {
      return this.$parent.currentPort;
    },
    total() {
      return sumBy(this.$parent.positions, 'worth');
    },
    noCashflow() {
      if (!this.currentPort.cashflow[0]) {
        return false;
      }
      const date = new Date();
      date.setUTCHours(0);
      date.setUTCMinutes(0);
      date.setUTCSeconds(1);
      if (this.currentPort.cashflow[0].interval === 'M') {
        date.setUTCMonth(date.getUTCMonth() - 1);
      } else if (this.currentPort.cashflow[0].interval === 'Y') {
        date.setUTCFullYear(date.getUTCFullYear() - 1);
      } else {
        date.setUTCMonth(date.getUTCMonth() - 3);
      }
      const storting = sumBy(
        filter(
          this.$parent.mutations,
          (o) => new Date(o.date) >= date && o.class === 'Storting' && !o.storno,
        ),
        'total',
      );
      if (storting >= this.currentPort.cashflow[0].value) {
        return false;
      }
      return true;
    },
    lastDeposit() {
      const date = new Date();
      date.setUTCHours(0);
      date.setUTCMinutes(0);
      date.setUTCSeconds(1);
      if (this.currentPort.cashflow[0].interval === 'M') {
        date.setUTCMonth(date.getUTCMonth() - 1);
      } else if (this.currentPort.cashflow[0].interval === 'Y') {
        date.setUTCFullYear(date.getUTCFullYear() - 1);
      } else {
        date.setUTCMonth(date.getUTCMonth() - 3);
      }
      const stortingen = filter(
        this.$parent.mutations,
        (o) => new Date(o.date) >= date && o.class === 'Storting' && !o.storno,
      );
      let total = 0;
      for (let i = 0; i < stortingen.length; i += 1) {
        total += stortingen[i].total;
        if (total >= this.currentPort.cashflow[0].value) {
          stortingen[i].nextDate = new Date(stortingen[i].date);
          if (this.currentPort.cashflow[0].interval === 'M') {
            stortingen[i].nextDate.setUTCMonth(stortingen[i].nextDate.getUTCMonth() + 1);
          } else if (this.currentPort.cashflow[0].interval === 'Y') {
            stortingen[i].nextDate.setUTCFullYear(stortingen[i].nextDate.getUTCFullYear() + 1);
          } else {
            stortingen[i].nextDate.setUTCMonth(stortingen[i].nextDate.getUTCMonth() + 3);
          }
          return stortingen[i];
        }
      }
      return {};
    },
    ports() {
      return this.$store.state.ports;
    },
    notUpToDate() {
      const currentPort = find(this.ports, { id: this.$parent.port });
      const now = new Date();
      const position = new Date(this.$parent.positions[0].date).toLocaleDateString();
      if (currentPort && now.toLocaleDateString() !== position && now.getUTCDay() !== 0) {
        if (currentPort.bank === 'BAL'
          || (now.getUTCDay() === 1 && currentPort.bank !== 'AAB')
          || (now.getUTCDay() === 6 && currentPort.bank === 'AAB')
        ) {
          return false;
        }
        return true;
      }
      return false;
    },
    daysTillGoal() {
      return (
        (new Date(this.currentPort.target_date)).getTime()
        - (new Date()).getTime()
      ) / 1000 / 24 / 60 / 60;
    },
  },
};
</script>

<style lang="scss" scoped>
  .dashboard-card {
    margin: 5px;
  }
  .editIcon {
    color: rgba(0,0,0,.4);
    &:hover {
      cursor: pointer;
      color: $color-highlight;
    }
    svg {
      height: 13px;
    }
  }
  .selected-profile {
    border: 1px solid $color-highlight;
    background-color: #A4D966;
  }
  .unselected-profile {
    background-color: #fff;
  }
  .transparent-table {
    tr {
      background-color: transparent;
    }
  }
</style>
